<template>
    <div class="d-flex flex-column">
        <div class="d-flex flex-row justify-end">
            <v-icon color="success" v-if="booked">mdi-checkbox-marked-circle</v-icon>
            <v-icon color="error" v-else-if="declined">mdi-close-circle</v-icon>
            <v-icon color="gray" v-else>mdi-help-circle</v-icon>

            <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        :loading="loading"
                        icon
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon color="primary">mdi-dots-horizontal-circle-outline</v-icon>
                    </v-btn>
                </template>

                <v-list>
                    <v-list-item @click="book" v-if="canBook()" :disabled="missingMembership">
                        <v-list-item-content>
                            <v-list-item-title>{{$translate('Book')}}</v-list-item-title>
                            <v-list-item-subtitle v-if="missingMembership">{{$translate('Membership required')}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="buyMembership" v-if="missingMembership">
                        <v-list-item-title>{{$translate('Buy membership')}}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="cancel" v-if="booked">
                        <v-list-item-title>{{$translate('CANCEL_BOOKING')}}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="decline" v-if="!booked && !declined">
                        <v-list-item-title>{{$translate('Decline')}}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="undoDecline" v-if="declined">
                        <v-list-item-title>{{$translate('Undo answer')}}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </div>
        <div v-if="booked" class="success--text">{{$translate('Registered2')}}</div>
        <div v-else-if="declined" class="error--text text-no-wrap">{{$translate('Declined')}}</div>
        <div v-else class="secondary--text text-no-wrap">{{$translate('Not booked2')}}</div>
        <buy-membership-dialog v-model="showBuyMembershipDialog"></buy-membership-dialog>
    </div>
</template>

<script>
import BuyMembershipDialog from '../components/BuyMembershipDialog.vue';

export default {
    name: 'zoezi-teamsport-book-match',

    props: ['match', 'teamId', 'bookingOption'],

    components: {
        BuyMembershipDialog
    },

    computed: {
        booked() {
            return !!this.$store.state?.bookings?.workouts.find(w => this.match.team_activities.includes(w.id));
        },
        declined() {
            return this.formation?.find(x => x.id == this.$store.state.user.id)?.status == 'declined';
        },
        invited() {
            return this.formation?.find(x => x.id == this.$store.state.user.id)?.status == 'invited';
        },
        ourActivityId() {
            const index = this.match.teams.findIndex(t => t.id == this.teamId);
            const activityId = this.match.team_activities[index];
            return activityId;
        },
        membershipRequired() {
            const registration = this.$store.state?.bookings?.teamsportbookings?.find(b => b.id == this.teamId);
            return registration?.competition?.require_membership;
        },
        missingMembership() {
            return this.$booking.isMembershipRequired([{product: {requireMembership: this.membershipRequired}, users: [this.$store.state.user.id]}]);
        }
    },

    watch: {
        match: {
            immediate: true,
            handler() {
                if (this.match) {
                    this.getFormation();
                }
            }
        }
    },

    data: () => ({
        loading: false,
        formation: null,
        unsubscribe: [],
        showBuyMembershipDialog: false
    }),

    methods: {
        possiblyShowError(response) {
            if (!response.ok) {
                response.json().then(data => {
                    this.$store.commit('showErrorDialog', {title: 'Fel', text: 'Något gick fel. ' + this.$translate(data.message)});
                });
            }
        },
        buyMembership() {
            this.showBuyMembershipDialog = true;
        },
        book() {
            this.loading = true;
            this.$api.post('/api/memberapi/workoutBooking/add', null, { workout: this.ourActivityId, method: 'trainingcard' }).then(response => {
                this.loading = false;
                this.possiblyShowError(response);
            })
        },
        cancel() {
            this.loading = true;
            this.$api.post('/api/memberapi/workoutBooking/remove', null, {workout: this.ourActivityId}).then(response => {
                this.loading = false;
                this.possiblyShowError(response);
            })
        },
        decline() {
            this.loading = true;
            this.$api.post('/api/memberapi/workoutBooking/invites/preemptive_decline', null, { workout: this.ourActivityId }).then(response => {
                this.loading = false;
                this.possiblyShowError(response);
            });
        },
        undoDecline() {
            this.loading = true;
            this.$api.post('/api/memberapi/workoutBooking/invites/undo_decline', null, { workout: this.ourActivityId }).then(response => {
                this.loading = false;
                this.possiblyShowError(response);
            });
        },
        getFormation() {
            this.loading = true;
            this.$api.get('/api/teamsport/match/team/formation/status', { match: this.match.id, team_id: this.teamId }).then(formation => {
                this.formation = formation;
                this.loading = false
            });
        },
        canBook() {
            return !this.booked && (this.bookingOption=='autoInvite' || this.invited);
        }
    },
    mounted() {
        this.unsubscribe.push(this.$api.subscribe({type: 'workoutbooking',  callback: (_, event) => {
            if (event.data.find(item => item.workout == this.ourActivityId)) {
                this.getFormation();
            }
        }}));
        this.unsubscribe.push(this.$api.subscribe({type: 'workoutbookinginvite', callback: (_, event) => {
            if (event.data.find(item => item.workout_id == this.ourActivityId)) {
                this.getFormation();
            }
        }}));
    },
    destroyed() {
        this.unsubscribe.forEach(x => x());
    }
}
</script>
